function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxNoUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,40A20,20,0,1,1,40,19.92,20,20,0,0,1,20,40ZM20,2.44A17.48,17.48,0,1,0,37.48,19.92,17.47,17.47,0,0,0,20,2.44Z",
    style: {
      fill: "#bdccd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.58,22.52a1.26,1.26,0,0,1-.92-.34l-4-4.2a1.25,1.25,0,0,1,1.76-1.76l3.19,3.19L27,12a1.25,1.25,0,1,1,1.76,1.76L20.5,22.1A1.35,1.35,0,0,1,19.58,22.52Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 5.21,
    r: 1.18,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 34.71,
    r: 1.18,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.71,
    cy: 19.92,
    r: 1.18,
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.29,
    cy: 19.92,
    r: 1.18,
    style: {
      fill: "#3f3d56"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxNoUpdates);
export default __webpack_public_path__ + "static/media/gfx-no-updates.cfec33bbe83f57d3a6079bc29f9eeb74.svg";
export { ForwardRef as ReactComponent };